import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {ViewModelProperty} from "../../models";

@Component({
    selector: 'ldw-settings-form',
    templateUrl: './settings-form.component.html',
    styleUrls: ['./settings-form.component.css'],
    standalone: false
})
export class SettingsFormComponent {

  form: UntypedFormGroup = new UntypedFormGroup({});

  @Input() captionWidth = 230;
  @Input() settings: Array<Array<ViewModelProperty>> = [];

}
